import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { decodeJWT } from '@gsmlg/utils/dist/authorization/jwt';

type TokenType = {
  header: {
    typ: string;
    alg: string;
  };
  payload: object;
  signature: string;
};

@customElement('jwt-viewer')
export class JwtViewer extends LitElement {
  static override styles = css`
    :root {
      width: inherit;
      height: inherit;
      font-size: inherit;
    }
    .row {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
    }
    .row:not(:last-child) {
      border-bottom: 1px solid #64c2c7;
    }
    .row > label,
    .row > div {
      display: inline-flex;
      margin: 0.3rem 2rem;
    }
    .row > label {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;
      width: 8rem;
      text-align: right;
      color: cadetblue;
    }
    .row > label::after {
      display: inline-flex;
      content: ':';
      color: hotpink;
    }
    .column {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .value {
      color: cornflowerblue;
      display: flex;
      flex-direction: column;
    }
  `;

  @property({ type: String, reflect: true, attribute: true })
  token: string = '';

  override attributeChangedCallback(
    name: string,
    old: string | null,
    value: string | null,
  ) {
    super.attributeChangedCallback(name, old, value);
    this.requestUpdate();
  }

  override render() {
    const p: TokenType = decodeJWT(this.token);

    const renderPayload = (payload) => {
      if (typeof payload !== 'object') {
        return html`${payload}`;
      }
      return html`
        ${Object.keys(payload).map(
          (k) => html`
            <div class="row">
              <label>${k}</label>
              <div class="value">${renderPayload(payload[k])}</div>
            </div>
          `,
        )}
      `;
    };
    return html`
      <div class="column">
        <div class="row">
          <label>Header</label>
          <div class="column">
            <div class="row">
              <label>Algorithm</label>
              <div class="value">${p.header.alg}</div>
            </div>
            <div class="row">
              <label>Type</label>
              <div class="value">${p.header.typ}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <label>Payload</label>
          <div class="column">${renderPayload(p.payload)}</div>
        </div>
        <div class="row">
          <label>signature</label>
          <div class="value">${p.signature}</div>
        </div>
      </div>
    `;
  }
}
